import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Facebook, Send, Link2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useToast } from "@/hooks/use-toast";

export default function CommunicationsDashboard() {
  const { toast } = useToast();

  return (
    <div className="space-y-4 animate-fade-in">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-foreground">Communications Dashboard</h1>
      </div>

      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle>Facebook Integration</CardTitle>
          <CardDescription>Connect and post to your PTA's Facebook page</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-between p-4 border border-border rounded-lg">
            <div className="flex items-center gap-3">
              <Facebook className="h-8 w-8 text-blue-600" />
              <div>
                <p className="font-semibold">Facebook Page</p>
                <p className="text-sm text-muted-foreground">Hillside Primary PTA</p>
              </div>
            </div>
            <Switch defaultChecked />
          </div>

          <div className="p-4 bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800 rounded-lg">
            <p className="text-sm text-blue-800 dark:text-blue-200">
              Facebook integration must be enabled by a PTA Admin before you can post from this dashboard.
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle>Create Facebook Post</CardTitle>
          <CardDescription>Post directly to your Facebook page</CardDescription>
        </CardHeader>
        <CardContent>
          <form className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="post-content">Post Content</Label>
              <Textarea
                id="post-content"
                placeholder="Share news, events, or updates with your community..."
                rows={6}
              />
            </div>

            <div className="space-y-2">
              <Label>Attach Link (Optional)</Label>
              <div className="flex gap-2">
                <div className="flex-1 flex items-center gap-2 p-3 border border-border rounded-lg">
                  <Link2 className="h-4 w-4 text-muted-foreground" />
                  <span className="text-sm text-muted-foreground">No link attached</span>
                </div>
                <Button type="button" variant="outline">Add Link</Button>
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <Button type="button" variant="outline">Save Draft</Button>
              <Button type="submit" onClick={(e) => {
                e.preventDefault();
                toast({
                  title: "Post published!",
                  description: "Your post has been shared to Facebook.",
                });
              }}>
                <Send className="h-4 w-4 mr-2" />
                Post to Facebook
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>

      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle>Recent Posts</CardTitle>
          <CardDescription>Your latest Facebook activity</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="p-4 border border-border rounded-lg">
              <div className="flex items-start gap-3 mb-2">
                <Facebook className="h-5 w-5 text-blue-600 mt-0.5" />
                <div className="flex-1">
                  <p className="text-sm mb-2">
                    🎉 Summer Fair is just around the corner! Join us on June 15th for games, food, and family fun. 
                    All proceeds go towards our new playground equipment fund!
                  </p>
                  <p className="text-xs text-muted-foreground">Posted 2 hours ago</p>
                </div>
              </div>
              <div className="flex gap-4 text-sm text-muted-foreground ml-8">
                <span>👍 24 Likes</span>
                <span>💬 5 Comments</span>
                <span>🔄 3 Shares</span>
              </div>
            </div>

            <div className="p-4 border border-border rounded-lg">
              <div className="flex items-start gap-3 mb-2">
                <Facebook className="h-5 w-5 text-blue-600 mt-0.5" />
                <div className="flex-1">
                  <p className="text-sm mb-2">
                    📚 Thank you to everyone who supported our bake sale! We raised £125 towards new library books.
                  </p>
                  <p className="text-xs text-muted-foreground">Posted yesterday</p>
                </div>
              </div>
              <div className="flex gap-4 text-sm text-muted-foreground ml-8">
                <span>👍 45 Likes</span>
                <span>💬 12 Comments</span>
                <span>🔄 8 Shares</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
